// opervex-frontend/src/utils/SearchHelp.js
/* eslint-disable no-unused-vars */

import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import SearchHelp from "../components/SearchHelp";

export const SearchHelpModal = ({ schema, urlData, size, autoFilter, preFilters, noFilter }) => {
  return new Promise((resolve) => {
    const div = document.createElement("div");
    document.body.appendChild(div);

    const root = ReactDOM.createRoot(div);

    const SearchHelpWrapper = () => {
      const [show, setShow] = useState(true);

      const handleClose = () => {
        setShow(false);
        setTimeout(() => {
          root.unmount();
          div.remove();
          resolve(null); // Resolve null se apenas fechou o modal
        }, 300);
      };

      const handleSelect = (item) => {
        setShow(false);
        setTimeout(() => {
          root.unmount();
          div.remove();
          resolve(item); // Resolve com o item selecionado
        }, 300);
      };

      return (
        <SearchHelp
          showModal={show}
          noFilter={noFilter}
          setShowModal={setShow}
          onSelectItem={handleSelect}
          urlData={urlData}
          autoFilter={autoFilter}
          size={size}
          preFilters={preFilters}
          schema={schema}
        />
      );
    };

    root.render(<SearchHelpWrapper />);
  });
};
